<template>
  <div class="unsubscribe-page">
    <Navbar />
    <div class="content">
      <h1>電子報退訂</h1>
      <p v-if="loading">處理中...</p>
      <p v-else-if="success">已完成退訂。</p>
      <p v-else>{{ errorMessage }}</p>
    </div>
    <FooterSection />
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import Navbar from "@/components/Navbar.vue";
import FooterSection from "@/components/FooterSection.vue";
import { newsletterAPI } from "@/services/api.js";

const route = useRoute();
const loading = ref(true);
const success = ref(false);
const errorMessage = ref("退訂失敗，請稍後再試。");

onMounted(async () => {
  try {
    await newsletterAPI.unsubscribe({ token: route.query.token || "" });
    success.value = true;
  } catch (error) {
    errorMessage.value = error?.response?.data?.message || errorMessage.value;
  } finally {
    loading.value = false;
  }
});
</script>

<style scoped>
.unsubscribe-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.content {
  flex: 1;
  max-width: 720px;
  margin: 0 auto;
  padding: 80px 20px;
}

h1 {
  margin-bottom: 16px;
}
</style>
